import MyDateTime from "../../../DTechComp/MyDateTime";

//מציג ללקוח את הימים החריגים שהוגדרו לעסק, כאינדיקציה לשינויים
//בשעות בתאריכים האלה (חגים, אירועים וכו').
//
//לכל חריגה: שם, טווח תאריכים, ולכל ערוץ (פתיחה / איסוף / משלוחים)
//השעות האפקטיביות באותו תאריך - מחושבות דרך
//MyDateTime.effectiveChannelHours, שמטפל בעוגני "שעת בסיס" של
//המאסטר וגם בחריגות מאסטר גלובליות (למשל "צאת שבת").
//
//חריגות שכבר עברו (toDate < היום בישראל) מוסתרות. המיון לפי
//תאריך התחלה עולה, כדי שהקרובה ביותר תופיע ראשונה.
//
//props:
//  currP  - אובייקט העסק (מכיל dateSpecilsBlocks + טבלאות השעות)
//  master - אובייקט המאסטר (baseHoursSets + dateSpecilsBlocks גלובליים)

const EXC_CHANNELS = [
    { key: "OpeningHours", label: "פתיחה" },
    { key: "TakeAwayHours", label: "איסוף" },
    { key: "DeliveryHours", label: "משלוחים" }
];

//"YYYY-MM-DD" -> "DD/MM/YYYY". קלט לא תקין מוחזר כמו שהוא
const dispDate = (key) => {
    if (typeof key !== "string") return "";
    const m = key.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    return m ? `${m[3]}/${m[2]}/${m[1]}` : key;
}

const RestDateExceptions = (props) => {

    const currP = props.currP;
    const master = props.master;

    const list = Array.isArray(currP?.dateSpecilsBlocks) ? currP.dateSpecilsBlocks : [];
    if (list.length === 0) return null;

    const todayKey = MyDateTime.getIsraelDateKey();

    //חריגות פעילות שעוד לא הסתיימו, ממוינות לפי תאריך התחלה
    const upcoming = list
        .filter(exc => exc && exc.active !== false && exc.fromDate)
        .filter(exc => (exc.toDate || exc.fromDate) >= todayKey)
        .sort((a, b) => (a.fromDate < b.fromDate ? -1 : a.fromDate > b.fromDate ? 1 : 0));

    if (upcoming.length === 0) return null;

    //שם היום בשבוע של תאריך "YYYY-MM-DD" - לצורך fallback הפנימי של
    //effectiveChannelHours. בונים Date מהחלקים בצהריים כדי לא ליפול
    //ליום הקודם עקב פרשנות UTC
    const dayNameOfKey = (key) => {
        const m = (key || "").match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (!m) return "";
        const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 12, 0, 0, 0);
        return MyDateTime.getIsraelDayName(d);
    }

    //מחזיר את השעות האפקטיביות של ערוץ בתאריך החריגה כטקסט מנורמל:
    //"סגור" או "HH:MM-HH:MM"
    const chanText = (exc, channelKey) => {
        const dayName = dayNameOfKey(exc.fromDate);
        const res = MyDateTime.effectiveChannelHours(
            currP, master, channelKey, exc.fromDate, dayName);

        if (!res || res.Closed) return "סגור";

        const open = MyDateTime.normalizeHM(res.Open);
        const close = MyDateTime.normalizeHM(res.Close);
        if (open === "" || close === "" || (open === "00:00" && close === "00:00")) {
            return "סגור";
        }
        return open + "-" + close;
    }

    //אם שלושת הערוצים יוצאים זהים - שורה אחת מרוכזת ("העסק סגור" /
    //"פתוח 12:00-22:00"). אחרת null, ואז מציגים פירוט לכל ערוץ
    const combinedText = (exc) => {
        const vals = EXC_CHANNELS.map(ch => chanText(exc, ch.key));
        if (vals[0] !== vals[1] || vals[1] !== vals[2]) return null;
        return vals[0] === "סגור" ? "העסק סגור" : "פתוח " + vals[0];
    }

    return (
        <>
            <div className={"bold veryBig spaceme15"}>ימים חריגים</div>
            <span className={"restExcNote"}>
                בתאריכים הבאים השעות שונות מהרגיל
            </span>

            {upcoming.map((exc, idx) => {
                const from = exc.fromDate;
                const to = exc.toDate || exc.fromDate;
                const isRange = to !== from;
                const combined = combinedText(exc);

                return (
                    <div className={"restExcItem"} key={exc.id || idx}>
                        <div className={"restExcHead"}>
                            <span className={"restExcName"}>{exc.name || "יום חריג"}</span>
                            <span className={"restExcDates"}>
                                {isRange
                                    ? dispDate(from) + " – " + dispDate(to)
                                    : dispDate(from)}
                            </span>
                        </div>
                        <div className={"restShortText restExcHours"}>
                            {combined
                                ? <p className={"DDS"}>{combined}</p>
                                : EXC_CHANNELS.map(ch => (
                                    <p className={"DDS"} key={ch.key}>
                                        {ch.label + " : " + chanText(exc, ch.key)}
                                    </p>
                                ))}
                        </div>
                    </div>
                );
            })}
        </>
    );
}

export default RestDateExceptions;
